<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <alert-message></alert-message>

            <v-row v-if="!isEdit">
              <v-col v-for="(file, idx) in form.files" :key="idx" cols="12" class="d-flex">                
                <v-file-input
                  v-model="form.files[idx]"
                  chips
                  counter
                  :show-size="1000"
                  :label="`Select File [${idx+1}] *`"
                  @change="readFiles(idx)"
                  :hint="showHint(idx)"
                ></v-file-input>                
                <v-btn @click="removeFiles(idx)" x-large icon><v-icon>mdi-delete</v-icon></v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn @click="addFiles()" x-small><v-icon>mdi-plus</v-icon> File</v-btn>
              </v-col>
              <hr />
            </v-row>

            <!-- <v-row v-else>
              <v-col>
                <v-text-field v-model="form.name" label="File Name" />
              </v-col>
            </v-row> -->

            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <vault-folder-select
                  v-model="form.folderId"
                  label="Folder"
                  :error-messages="[].concat(fieldErrors('form.folderId'))"
                  @blur="$v.form.folderId.$touch()"
                />
              </v-col>
            </v-row> -->
            <!-- 
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <tags-select
                  v-model="form.tags"
                  label="Tags"
                  :error-messages="[].concat(fieldErrors('form.tags'))"
                  @blur="$v.form.tags.$touch()"
                />
              </v-col>
            </v-row> -->

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.notes"
                  label="Notes"
                  :error-messages="[].concat(fieldErrors('form.notes'))"
                  @blur="$v.form.notes.$touch()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Upload" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
// import VaultFolderSelect from "components/StorageFolderSelect.vue";
import formatterMixin from "@/mixins/formatterMixin";
// import TagsSelect from "components/TagSelect.vue";
import { storageFolderService } from "src/services/api";
import { storageService } from "src/services/api";
import { taskService } from "src/services/api";

const defaultInputs = {
  id: 0,
  accountId: 0,
  name: "string",
  notes: "",
  tags: [],
  folderId: "",
  permissions: [],
  file: "",
  files: [],
};

export default {
  components: {
    AlertMessage,
    // VaultFolderSelect,
    // TagsSelect,
  },
  props: {
    clientId: Number,
    item: Object,
    task: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      id: {},
      name: {},
      accountId: {},
      file: { },
      files: { required },
      notes: {},
      folderId: {},
      tags: {},
    },
  },
  validationMessages: {
    form: {
      id: {},
      clientId: { required: "Required" },
      accountId: {},
      file: {},
      files: {},
      name: { required: "Required" },
      notes: { required: "Required" },
      folderId: { required: "Required" },
      tags: {},
    },
  },

  data() {
    return {
      showDialog: this.show,
      form: {
        ...defaultInputs,
      },
      dialog: false,
      valid: false,
      loading: false,
      fileValue: undefined,
      fileLoaded: 0,
      permissions: [],
      filesLoaded: [],
    };
  },

  async mounted() {},

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    async dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
      await this.setInitialFolder();
    },

    folderId(newFolderId) {
      if (!this.isEdit && newFolderId) {
        this.form.folderId = newFolderId;
      }
    },

    async item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        let tags = [];
        if (newTask.categories && newTask.categories.length > 0) {
          tags = newTask.categories.map((i) => i.id);
        }
        this.permissions = newTask.permissions;
        this.form = {
          ...newTask,
          folderId: newTask.folderId === null ? "" : newTask.folderId,
          tags,
        };
      } else {
        this.permissions = this.defaultItems;
        this.form = {
          ...defaultInputs,
          folderId: this.folderId,
          permissions: this.defaultItems,
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      userGroups: (state) => state.userGroup.data,
      user: (state) => state.account.data.user,
      storage: (state) => state.storage,
      alert: (state) => state.alert,
      storageFolders: (state) => state.storageFolder.data,
    }),

    defaultItems() {
      let items = [];
      this.userGroups.forEach((item) => {
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 1,
          access: item.name == "Super Admin" ? true : false,
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 3,
          access: item.name == "Super Admin" ? true : false,
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 4,
          access: item.name == "Super Admin" ? true : false,
        });
      });
      return items;
    },

    getAdminGroup() {
      let found = this.userGroups.filter((item) => item.name == "Super Admin");
      if (found.length === 1) {
        return found[0];
      } else {
        return null;
      }
    },

    formTitle() {
      return this.isEdit ? `Edit File "${this.item.name}"` : "Upload New File";
    },
    isEdit() {
      return this.optional(this.item, "id", "") ? true : false;
    },
    taskId() {
      return this.optional(this.item, "id", "");
    },
    folderId() {
      let { folderId } = this.$route.query;
      if (folderId) {
        return parseInt(folderId);
      }
      return "";
    },
    computedPermissions() {
      let permissions = [];
      this.permissions.map((perm) => (permissions = [...permissions, ...perm]));
      return permissions;
    },
  },

  methods: {
    ...mapActions("storage", ["upload", "update"]),
    async setInitialFolder() {
      // set permission
      // need to be refactor
      this.permissions = [
        {
          userGroupId: this.account.data.user.userGroupId,
          userGroupName: this.account.data.user.userGroupName,
          userActionId: 1,
          access: true,
        },
        {
          userGroupId: this.account.data.user.userGroupId,
          userGroupName: this.account.data.user.userGroupName,
          userActionId: 3,
          access: true,
        },
        {
          userGroupId: this.account.data.user.userGroupId,
          userGroupName: this.account.data.user.userGroupName,
          userActionId: 4,
          access: true,
        },
      ];

      let listAll = await storageService.getFolder({
        searchTerm: "Jobs",
      });
      let foundFolder = listAll.folders.filter((folder) => {
        return folder.name == "Jobs";
      });

      //create parent folder
      let parentId = null;
      if (foundFolder.length === 1) {
        parentId = foundFolder[0];
      } else {
        parentId = await storageFolderService.create({
          name: "Jobs",
          parentId: null,
          permissions: this.permissions,
        });
      }

      let listJobsAll = await storageService.getFolder({
        searchTerm: `#${this.task.id}`,
        folderId: parentId.id,
      });
      let foundFolder2 = listJobsAll.folders.filter((folder) => {
        return folder.name == `#${this.task.id}`;
      });
      let folderId = null;
      if (foundFolder2.length === 1) {
        folderId = foundFolder2[0];
      } else {
        folderId = await storageFolderService.create({
          name: `#${this.task.id}`,
          parentId: parentId.id,
          permissions: this.permissions,
        });
      }
      //create jobs folder

      this.form.folderId = folderId.id;
      // need to be refactor
    },
    initForm() {
      if (this.clientId) {
        this.form = {
          ...this.form,
        };
      }
    },

    showHint(idx) {
      return this.filesLoaded[idx] && this.filesLoaded[idx]['sizeLoaded'] >= 100 ? `File ready to upload` : '';
    },

    addFiles() {
      this.form.files.push(null);
      this.filesLoaded.push({
        sizeLoaded: 0,
        value: null
      });
    },

    removeFiles(idx) {    
      this.form.files.splice(idx, 1);
      this.filesLoaded.splice(idx, 1);
    },


    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.permissions = [];
      this.form = defaultInputs;
      this.filesLoaded = [];      
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.permissions = [];
      this.$emit("onSucceded");
    },

    readFile() {
      this.fileLoaded = 0;
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        const result = event.target.result;
        this.fileValue = result;
        // Do something with result
      });

      reader.addEventListener("progress", (event) => {
        if (event.loaded && event.total) {
          const percent = (event.loaded / event.total) * 100;
          this.fileLoaded = Math.round(percent);
          console.log(`Progress: ${Math.round(percent)}`);
        }
      });
      if (this.form.file) {
        reader.readAsDataURL(this.form.file);
      }
    },

    readFiles(idx) {
      this.filesLoaded[idx]['sizeLoaded'] = 0;
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        const result = event.target.result;
        this.filesLoaded[idx]['value'] = result;
        // Do something with result
      });

      reader.addEventListener("progress", (event) => {
        if (event.loaded && event.total) {
          const percent = (event.loaded / event.total) * 100;
          this.filesLoaded[idx]['sizeLoaded'] = Math.round(percent);
        }
      });
      if (this.form.files[idx]) {
        reader.readAsDataURL(this.form.files[idx]);
      }
    },    

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      if (this.isEdit) {
        let payload = {
          ...this.form,
        };
        delete payload.file;
        await this.update({
          id: this.taskId,
          ...payload,
          folderId: this.form.folderId === "" ? null : this.form.folderId,
          permissions: this.permissions,
        });
      } else {
        const formData = new FormData();
        this.form.files.map(file => {
          formData.append("Files", file);
        });
        
        formData.append("FolderId", this.form.folderId);
        formData.append("Notes", this.form.notes);
        this.form.tags.map((tag) => {
          formData.append("Tags", tag);
        });
        this.permissions.map((permission) => {
          formData.append("Permissions", JSON.stringify(permission));
        });
        await this.upload(formData);

        if (!this.storage.status.error) {
          let { data } = this.storage.single;
          let fileIDs = data.map(file =>
            file.id
          );
          console.log(fileIDs);
          await taskService.addAttachments({
            id: this.task.id,
            attachmentIds: fileIDs,
          });
        }
      }

      if (!this.storage.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
      this.permissions = [];
    },
  },
};
</script>